/**
 * The desired margin between non-full-screen floating UI elements (e.g. modals, popouts, dropdowns...) and the edge of
 * the screen, in pixels.
 *
 * @type {number}
 */
export const FLOATING_UI_SCREEN_EDGE_MARGIN_PX = 36;